(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('dashboardTopStatsService', dashboardTopStatsService);

  function dashboardTopStatsService() {
    const affiliateDefaultColumns = ['name', 'live', 'hour', 'numberimp', 'inboundcall', 'convertedcall', 'conversionsum', 'payoutsum', 'profit'];
    const targetDefaultColumns = ['name', 'live', 'hour', 'connectedcall', 'convertedcall', 'conversionsum'];
    const campaignDefaultColumns = ['name', 'live', 'hour', 'numberimp', 'inboundcall', 'convertedcall', 'conversionsum', 'payoutsum', 'profit'];

    const topColumnSettings = {
      name: {
        align: 'left',
        stSort: 'name',
        class: 'width-20-percent',
        displayName: 'DASHBOARD_TOPLIST_PANEL_PUBLISHERS_NAME',
        rowAlign: 'left'
      },
      live: {
        class: 'column-sortable text-right p-r-0',
        align: 'right',
        stSort: 'values.live',
        displayName: 'DASHBOARD_TOPLIST_PANEL_LIVE',
        rowAlign: 'right'
      },

      numberimp: {
        class: 'column-sortable text-right p-r-0',
        align: 'right',
        stSort: 'values.numberimp',
        displayName: 'DASHBOARD_TOPLIST_PANEL_IMPRESSIONS',
        rowAlign: 'right'
      },
      hour: {
        class: 'column-sortable text-right p-r-0',
        align: 'right',
        stSort: 'values.hour',
        displayName: 'DASHBOARD_TOPLIST_PANEL_HOUR',
        rowAlign: 'right'
      },
      inboundcall: {
        class: 'column-sortable text-right p-r-0',
        align: 'right',
        stSort: 'values.inboundcall',
        displayName: 'DASHBOARD_TOPLIST_PANEL_CALLS',
        rowAlign: 'right'
      },
      convertedcall: {
        class: 'column-sortable text-right p-r-0',
        stSort: 'values.convertedcall',
        displayName: 'DASHBOARD_TOPLIST_PANEL_CONVERSIONS',
        rowAlign: 'right',
        align: 'right'
      },
      conversionsum: {
        class: 'column-sortable text-right p-r-0',
        align: 'right',
        stSort: 'values.conversionsum',
        displayName: 'DASHBOARD_TOPLIST_PANEL_REVENUE',
        rowAlign: 'right'
      },
      payoutsum: {
        class: 'column-sortable text-right p-r-0',
        stSort: 'values.payoutsum',
        displayName: 'DASHBOARD_TOPLIST_PANEL_PAYOUT',
        rowAlign: 'right',
        align: 'right'
      },
      profit: {
        class: 'column-sortable text-right p-r-0',
        stSort: 'values.conversionsum - values.payoutsum',
        displayName: 'DASHBOARD_TOPLIST_PANEL_PROFIT',
        rowAlign: 'right',
        align: 'right'
      }
    };

    const targetColumnSettings = {
      name: {
        align: 'left',
        stSort: 'name',
        class: 'width-20-percent',
        displayName: 'DASHBOARD_TOPLIST_PANEL_PUBLISHERS_NAME',
        rowAlign: 'left'
      },
      live: {
        class: 'column-sortable text-right p-r-0',
        align: 'right',
        stSort: 'values.live',
        displayName: 'DASHBOARD_TOPLIST_PANEL_LIVE',
        rowAlign: 'right'
      },
      hour: {
        class: 'column-sortable text-right p-r-0',
        align: 'right',
        stSort: 'values.hour',
        displayName: 'DASHBOARD_TOPLIST_PANEL_HOUR',
        rowAlign: 'right'
      },
      connectedcall: {
        class: 'column-sortable text-right p-r-0',
        align: 'right',
        stSort: 'values.connectedcall',
        displayName: 'DASHBOARD_TOPLIST_PANEL_CALLS',
        rowAlign: 'right'
      },
      convertedcall: {
        class: 'column-sortable text-right p-r-0',
        stSort: 'values.convertedcall',
        displayName: 'DASHBOARD_TOPLIST_PANEL_CONVERSIONS',
        rowAlign: 'right',
        align: 'right'
      },
      conversionsum: {
        class: 'column-sortable text-right p-r-0',
        align: 'right',
        stSort: 'values.conversionsum',
        displayName: 'DASHBOARD_TOPLIST_PANEL_REVENUE',
        rowAlign: 'right'
      }
    };

    const service = {
      topColumnSettings: topColumnSettings,
      affiliateDefaultColumns: affiliateDefaultColumns,
      targetDefaultColumns: targetDefaultColumns,
      campaignDefaultColumns: campaignDefaultColumns,
      targetColumnSettings: targetColumnSettings
    };

    return service;

  }
})();
